
const sideBarStyles = (open) => {
  return (
    {
      root: {
        right: 'auto',
        bottom: 'auto',
        overflow: 'visible',
        zIndex: 1000,
      },
      sidebar: {
        zIndex: 300,
        position: 'fixed',
        top: 0,
        bottom: 0,
        transition: "transform .3s ease-out",
        WebkitTransition: "-webkit-transform .3s ease-out",
        willChange: "transform",
        overflowY: "auto",
        backgroundColor: 'white'
      },
      content: {
        left: 'auto',
        bottom: 'auto',
        overflow: 'visible',
        WebkitOverflowScrolling: "touch",
        transition: "left .3s ease-out, right .3s ease-out"
      },
      overlay: {
        zIndex: 200,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0,
        visibility: "hidden",
        transition: "opacity .3s ease-out, visibility .3s ease-out",
        backgroundColor: "#009bdf6b",
        pointerEvents: open ? 'auto' : 'none'
      },
      dragHandle: {
        zIndex: 1,
        position: "fixed",
        top: 0,
        bottom: 0
      }
    }
  )

};

export { sideBarStyles }
